import React from 'react';
import Layout from '../components/Layout';

const Policy = () => {
  return (
    <Layout>
      <div className="page">
        <h1>Politică de confidențialitate</h1>
        <p>
          Acest website folosește cookie-uri pentru a furniza vizitatorilor o experiență mult mai
          bună de navigare și servicii adaptate nevoilor și interesului fiecăruia.
        </p>
        <p>
          "Cookie"-urile au rolul de a facilita accesul și livrarea serviciilor folosite de
          utilizator de internet, cum ar fi personalizarea anumitor setari (limba, țara, prețuri
          afișate în moneda națională. "Cookie"-urile, pe baza informațiilor pe care le adună despre
          utilizatori, îi ajută pe deținătorii de site-uri să își eficientizeze produsul astfel
          încât acesta să fie cât mai ușor accesat de către utilizatori, de asemenea cresc gradul de
          eficiență a publicității online și nu în ultimul rând pot permite aplicațiilor multimedia
          sau de alt tip de pe alte site-uri să fie incluse într-un anumit site pentru a face
          navigarea mai utilă.
        </p>
        <h2>Ce este un "cookie"?</h2>
        <p>
          Cookie ("browser cookie" sau "HTTP cookie") este un fișier de mici dimensiuni, format din
          litere și numere, care este stocat pe orice terminal cu acces la internet (computer,
          telefon mobil, tabletă etc.) și este instalat prin solicitara emisă de către un web-server
          unui browser (ex: Internet Explorer, Chrome). De reținut: "Cookie"-urile nu conțin
          programe software, viruși sau spyware și nu pot accesa informațiile de pe hard drive-ul
          utilizatorului.
        </p>
        <p>
          Un cookie este format din nume și conținut, durata de existență a acestuia fiind
          determinată, putând fi accesat din nou de webserver în momentul în care un utilizator se
          întoarce pe website-ul asociat webserverului respectiv.
        </p>
        <p>
          Cookie-urile nu solicită informații cu caracter personal și nu identifică personal
          utilizatorii de internet.
        </p>
        <p>
          Cookie-uri de sesiune - acestea sunt stocate temporar în istoricul browser-ului care le
          memorează până când utilizatorul iese de pe website-ul respectiv sau închide fereastra
          browserului.
        </p>
        <p>
          Cookie-uri Persistente - Acestea sunt stocate, în funcție de durata prestabilită, pe
          hard-drive-ul unui computer sau echipament. Cookie-urile persistente le includ și pe cele
          plasate de un alt website decât cel pe care îl vizitează utilizatorul la momentul
          respectiv - cunoscute sub numele de "third party cookies" - care pot fi folosite în mod
          anonim pentru a memora interesele unui utilizator, astfel încât să fie livrată publicitate
          cât mai relevantă pentru utilizatori.
        </p>
        <h2>Care sunt avantajele cookie-urilor?</h2>
        <p>
          Un cookie conține informații care fac legatura între utilizatori și un anume website. Dacă
          un browser accesează acel web-server din nou, acesta poate citi informația deja stocată și
          reacționa în consecință.
        </p>
        <h2>Care este durata de viață a unui cookie?</h2>
        <p>
          Există cookie-uri folosite exclusiv pentru o singura sesiune - acestea nu mai sunt
          retinute după ce utilizatorul iese de pe website. Cookie-uri permanente - sunt reținute și
          refolosite de fiecare dată când utilizatorul revine pe acel website, însă pot fi șterse
          oricând de utilizator.
        </p>
        <h2>Ce sunt cookie-urile plasate de terți?</h2>
        <p>
          Părți de conținut sau servicii pot fi plasate pe website-ul accesat, de către terțe părți
          prin intermediul bannerelor, box-urilor sau linkurilor - iar toate aceste instrumente pot
          conține cookie-uri. Ele se numesc "third party cookies" pentru că nu sunt plasate de
          proprietarul website-ului respectiv, iar furnizorii terți se supun legilor în vigoare și
          politicilor de confidențialitate ale deținătorului site-ului.
        </p>
        <h2>Cum sunt folosite cookie-urile de către acest site?</h2>
        <p>O vizită pe acest site poate plasa cookie-uri în scopuri de:</p>
        <ul>
          <li>Cookie-uri de analiză a vizitatorilor</li>
        </ul>
        <p>Unele cookie-uri pot proveni de la terți.</p>
        <h2>Cookie-uri pentru analiza vizitatorilor</h2>
        <p>
          De fiecare dată când un utilizator vizitează acest site softul de analytics furnizat de o
          terță parte generează un cookie de analiză a utilizatorului. Acest cookie ne spune dacă
          ați mai vizitat acest site până acum. Browser-ul ne va spune dacă aveți acest cookie, iar
          dacă nu, vom genera unul. Acesta permite monitorizarea utilizatorilor unici care ne
          vizitează și cât de des o fac. Acest cookie nu poate fi folosit pentru a identifica
          persoanele fizice, ele sunt folosite doar în scop statistic.
        </p>
        <h2>Alte cookie-uri ale terțelor parti</h2>
        <p>
          Pe unele pagini, terții pot seta propriile cookie-uri anonime, în scopul de a urmări
          succesul unei aplicații, sau pentru a customiza o aplicație. Datorită modului de
          utilizare, acest site nu poate accesa aceste cookie-uri, la fel cum terțele părți nu pot
          accesa cookie-urile deținute de acest site. De exemplu, când distribuiți o pagină folosind
          butonul pentru rețelele sociale aflat pe acest site, acea rețea socială va înregistra
          activitatea dvs.
        </p>
        <h2>Ce tip de informații sunt stocate și accesate prin intermediul cookie-urilor?</h2>
        <p>
          Cookie-urile păstrează informații într-un fișier text de mici dimensiuni care permit unui
          website să recunoască un browser. Webserver-ul va recunoaște browserul până când cookie-ul
          expiră sau este șters. Cookie-ul stochează informații importante care îmbunătățesc
          experiență de navigare pe Internet (ex: un număr de ordine pentru donația ta).
        </p>
        <h2>De ce sunt cookie-urile importante pentru Internet?</h2>
        <p>
          Cookie-urile reprezintă punctul central al funcționării eficiente a Internetului, ajutând
          la generarea unei experiențe de navigare prietenoase și adaptată preferințelor și
          intereselor fiecărui utilizator. Refuzarea sau dezactivarea cookie-urilor poate face unele
          site-uri imposibil de folosit.
        </p>
        <p>
          Refuzarea sau dezactivarea cookie-urilor nu înseamnă că nu veți mai primi publicitate
          online - ci doar ca aceasta nu va mai putea ține cont de preferințele și interesele dvs,
          evidențiate prin comportamentul de navigare.
        </p>
        <h2>Securitate și probleme legate de confidențialitate</h2>
        <p>
          Cookie-urile NU sunt viruși! Ele folosesc formate tip plain text. Nu sunt alcătuite din
          bucăți de cod așa că nu pot fi executate nici nu pot auto-rula. În consecință, nu se pot
          duplica sau replica pe alte rețele pentru a se rula sau replica din nou. Deoarece nu pot
          îndeplini aceste funcții, nu pot fi considerate viruși.
        </p>
        <p>
          Cookie-urile pot fi totuși folosite pentru scopuri negative. Deoarece stochează informații
          despre preferințele și istoricul de navigare al utilizatorilor, atât pe un anume site cât
          și pe mai multe alte siteuri, cookie-urile pot fi folosite ca o formă de Spyware. Multe
          produse anti-spyware sunt conștiente de acest fapt și în mod constant marchează
          cookie-urile pentru a fi șterse în cadrul procedurilor de ștergere/scanare
          anti-virus/anti-spyware.
        </p>
        <p>
          În general browserele au integrate setări de confidențialitate care furnizează diferite
          nivele de acceptare a cookie-urilor, perioada de valabilitate și ștergere automată după ce
          utilizatorul a vizitat un anumit site.
        </p>
        <h2>Alte aspecte de securitate legate de cookie-uri</h2>
        <p>
          Deoarece protecția identității este foarte valoroasă și reprezintă dreptul fiecărui
          utilizator de internet, este indicat să se știe ce eventuale probleme pot crea
          cookie-urile. Pentru că prin intermediul lor se transmit în mod constant în ambele sensuri
          informații între browser și website, dacă un atacator sau persoana neautorizata intervine
          în parcursul de transmitere a datelor, informațiile conținute de cookie pot fi
          interceptate. Deși foarte rar, acest lucru se poate întâmpla dacă browserul se conecteaza
          la server folosind o rețea necriptata (ex: o rețea WiFi nesecurizata).
        </p>
        <p>
          Alte atacuri bazate pe cookie implica setări gresite ale cookie-urilor pe servere. Dacă un
          website nu solicită browserului să folosească doar canale criptate, atacatorii pot folosi
          aceasta vulnerabilitate pentru a păcăli browserele în a trimite informații prin
          intermediul canalelor nesecurizate. Atacatorii utilizează apoi informațiile în scopuri de
          a accesa neautorizat anumite site-uri. Este foarte important să fiți atenți în alegerea
          metodei celei mai potrivite de protectie a informațiilor personale.
        </p>
        <h2>Sfaturi pentru o navigare sigură și responsabilă, bazată pe cookies</h2>
        <p>
          Datorită flexibilității lor și a faptului că majoritatea dintre cele mai vizitate site-uri
          și cele mai mari folosesc cookie-uri, acestea sunt aproape inevitabile. Dezactivarea
          cookie-urilor nu va permite accesul utilizatorului pe site-urile cele mai răspândite și
          utilizate printre care Youtube, Gmail, Yahoo și altele. Iată cateva sfaturi care va pot
          asigura că navigați fără griji însă cu ajutorul cookie-urilor:
        </p>
        <ul>
          <li>
            Particularizați-vă setarile browserului în ceea ce privește cookie-urile pentru a
            reflecta un nivel confortabil pentru voi al securității utilizarii cookie-urilor. Dacă
            nu vă deranjează cookie-urile și sunteți singura persoană care utilizează computerul,
            puteți seta termene lungi de expirare pentru stocarea istoricului de navigare și al
            datelor personale de acces. Dacă împărțiți accesul la calculator, puteți lua în
            considerare setarea browserului pentru a șterge datele individuale de navigare de
            fiecare dată când închideți browserul. Aceasta este o varianta de a accesa site-urile
            care plasează cookie-uri și de a șterge orice informație de vizitare la închiderea
            sesiunii navigare.
          </li>
          <li>Instalati-va și updatati-va constant aplicații antispyware.</li>
        </ul>
        <p>
          Multe dintre aplicațiile de detectare și prevenire a spyware-ului includ detectarea
          atacurilor pe site-uri. Astfel, împiedică browserul de la a accesa website-uri care ar
          putea sa exploateze vulnerabilitatile browserului sau sa descarce software periculos.
          Asigurati-va ca aveți browserul mereu updatat. Multe dintre atacurile bazate pe cookies se
          realizeaza exploatand punctele slabe ale versiunilor vechi ale browserelor.
        </p>
        <p>
          Cookie-urile sunt pretutindeni si nu pot fi evitate dacă doriți sa va bucurati de acces pe
          cele mai bune și cele mai mari site-uri de pe Internet - locale sau internaționale. Cu o
          înțelegere clară a modului lor de operare și a beneficiilor pe care le aduc, puteți lua
          măsurile necesare de securitate astel incat sa puteti naviga cu încredere pe internet.
        </p>
        <h2>Cum pot opri cookie-urile?</h2>
        <p>
          Dezactivarea și refuzul de a primi cookie-uri pot face anumite site-uri impracticabile sau
          dificil de vizitat și folosit. De asemenea, refuzul de a accepta cookie-uri nu înseamnă ca
          nu veți mai primi/vedea publicitate online.
        </p>
        <p>
          Este posibila setarea din browser pentru ca aceste cookie-uri sa nu mai fie acceptate sau
          poți seta browserul sa accepte cookie-uri de la un site anume. Dar, de exemplu, dacă nu
          dorești sa folosesti cookie-urile nu poti sa urmezi și pasii urmatori după înregistrarea
          completarea formularului.
        </p>
        <p>
          Toate browserele moderne oferă posibilitatea de a schimba setarile cookie-urilor. Aceste
          setari se găsesc de regula în "opțiuni" sau în meniul de "preferințe" al browserului tău.
        </p>
        <p>
          Pentru setarile cookie-urilor generate de terți, și pentru mai multe informații privind
          confidențialitatea legată de publicitatea online, IAB România pune la dispozitie urmatorul
          site:{' '}
          <a href="http://www.youronlinechoices.com/ro/" target="_blank" rel="noopener noreferrer">
            http://www.youronlinechoices.com/ro/
          </a>
        </p>
      </div>
    </Layout>
  );
};

export default Policy;
